import { Control, useWatch } from 'react-hook-form';

import { useTranslate } from '@/hooks/useTranslate';

import { TotalLine } from '../common';
import { LiabilityFormValues } from './type';

type LiabilitiesTotalLineProps = {
  control: Control<LiabilityFormValues>;
  currencyDisplay: string;
};

export function LiabilitiesTotalLine({
  control,
  currencyDisplay,
}: Readonly<LiabilitiesTotalLineProps>) {
  const { t } = useTranslate();
  const watchedLiabilities = useWatch({ control, name: 'liabilities' });

  const total = (watchedLiabilities ?? []).reduce(
    (sum, liability) =>
      sum + (liability?.amount ? Number(liability.amount) : 0),
    0,
  );

  return (
    <TotalLine
      label={t('moreInfo.form.yourFinances.liabilities.totalLabel')}
      value={`${currencyDisplay} ${total}`}
    />
  );
}
